var chunkMapping = {
	"31": [
		1319,
		2147,
		4686,
		4963,
		5817
	],
	"36": [
		137,
		828,
		2091,
		2391,
		2777,
		3580,
		5620,
		5894,
		6744,
		9283,
		9518,
		9684
	],
	"381": [
		7381
	],
	"686": [
		559,
		606,
		812,
		1012,
		1335,
		1681,
		1760,
		2591,
		2617,
		2710,
		2862,
		2948,
		5621,
		6122,
		6467,
		6586,
		6708,
		6765,
		7113,
		7576,
		7598,
		7693,
		8122,
		8147,
		8618,
		8739,
		9108,
		9255,
		9266,
		9493
	]
};
var idToExternalAndNameMapping = {
	"137": [
		"default",
		"./register",
		7883
	],
	"559": [
		"default",
		"./Page",
		8359
	],
	"606": [
		"default",
		"./charts/Treemap",
		8359
	],
	"812": [
		"default",
		"./icons/Document",
		8359
	],
	"828": [
		"default",
		"./UnboxingPageIntroduction",
		8235
	],
	"1012": [
		"default",
		"./Col",
		8359
	],
	"1319": [
		"default",
		"./icons/CustomTaste",
		8359
	],
	"1335": [
		"default",
		"./Text",
		8359
	],
	"1681": [
		"default",
		"./Divider",
		8359
	],
	"1760": [
		"default",
		"./Statistic",
		8359
	],
	"2091": [
		"default",
		"./icons/CustomTasteUnboxing",
		8359
	],
	"2147": [
		"default",
		"./Menu",
		8359
	],
	"2391": [
		"default",
		"./UnboxingPageHeader",
		8235
	],
	"2591": [
		"default",
		"./Tooltip",
		8359
	],
	"2617": [
		"default",
		"./TabPane",
		8359
	],
	"2710": [
		"default",
		"./Row",
		8359
	],
	"2777": [
		"default",
		"./Image",
		8359
	],
	"2862": [
		"default",
		"./Tabs",
		8359
	],
	"2948": [
		"default",
		"./Card",
		8359
	],
	"3580": [
		"default",
		"./UnboxingPageBody",
		8235
	],
	"4686": [
		"default",
		"./MenuItem",
		8359
	],
	"4963": [
		"default",
		"./History",
		1441
	],
	"5620": [
		"default",
		"./UnboxingPageRow",
		8235
	],
	"5621": [
		"default",
		"./Popover",
		8359
	],
	"5817": [
		"default",
		"./SubMenu",
		8359
	],
	"5894": [
		"default",
		"./UnboxingPageCol",
		8235
	],
	"6122": [
		"default",
		"./icons/UserFilled",
		8359
	],
	"6467": [
		"default",
		"./hooks",
		1441
	],
	"6586": [
		"default",
		"./Tag",
		8359
	],
	"6708": [
		"default",
		"./Panel",
		8359
	],
	"6744": [
		"default",
		"./UnboxingPage",
		8235
	],
	"6765": [
		"default",
		"./Avatar",
		8359
	],
	"7113": [
		"default",
		"./Option",
		8359
	],
	"7381": [
		"default",
		"./cWrapper",
		1441
	],
	"7576": [
		"default",
		"./Space",
		8359
	],
	"7598": [
		"default",
		"./List",
		8359
	],
	"7693": [
		"default",
		"./Selectors",
		1441
	],
	"8122": [
		"default",
		"./LookEmbed",
		5296
	],
	"8147": [
		"default",
		"./ListItem",
		8359
	],
	"8618": [
		"default",
		"./Button",
		8359
	],
	"8739": [
		"default",
		"./Collapse",
		8359
	],
	"9108": [
		"default",
		"./ListItemMeta",
		8359
	],
	"9255": [
		"default",
		"./Skeleton",
		8359
	],
	"9266": [
		"default",
		"./Select",
		8359
	],
	"9283": [
		"default",
		"./unboxing-page",
		8235
	],
	"9493": [
		"default",
		"./icons/InfoCircleOutlined",
		8359
	],
	"9518": [
		"default",
		"./UnboxingPageDocumentation",
		8235
	],
	"9684": [
		"default",
		"./UnboxingPageCrossSelling",
		8235
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}